export default {
  title: {
    en: 'Your subscription order',
  },
  shipping: {
    en: 'Will ship {shippingText} from our facility',
  },
}
